import { render, staticRenderFns } from "./Winlist.vue?vue&type=template&id=6537166b&scoped=true&"
import script from "./Winlist.vue?vue&type=script&lang=js&"
export * from "./Winlist.vue?vue&type=script&lang=js&"
import style0 from "./Winlist.vue?vue&type=style&index=0&id=6537166b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6537166b",
  null
  
)

export default component.exports